import { Color } from './dynamicTheming';
import { IMSObject, IMSId, LabelFormatSetting } from './ims-object';
import { format } from 'date-fns';

export class MaterialDelivery extends IMSObject {
  static fromDto(
    dto: MaterialDeliveryDTO,
    databag?: any,
    labelSettings?: LabelFormatSetting
  ) {
    const obj = new this(
      {
        imsId: dto.id,
        secondaryId: dto.secondaryid,
        objRef: 'ims/MaterialDelivery',
      },
      dto.label,
      labelSettings || {
        primary: {
          value: '{0}',
          databagKeys: ['label'],
        },
      },
      new IMSObject(
        dto.car.id,
        undefined,
        dto.car.label,
        'ims/MaterialDelivery'
      ),
      dto.description,
      dto.deliverydate
    );

    if (databag) {
      obj.databag = databag;
    } else {
      obj.databag = dto;
    }

    return obj;
  }

  public get deliveryDateFormated(): string {
    return this.deliverydate != undefined
      ? format(this.deliverydate, 'dd.MM.yyyy')
      : undefined;
  }

  public get isPreliminaryDeliveryDate(): boolean {
    return this.databag['ispreliminarydeliverydate'];
  }

  public get deliveryDateCode(): boolean {
    return this.databag['deliverydatecode'];
  }

  public get deliveryDateInfo(): boolean {
    return this.databag['deliverydateinfo'];
  }

  public get preliminaryPrefix(): string {
    return this.isPreliminaryDeliveryDate ? '*' : '';
  }

  public get preliminaryColorCode(): Color {
    return this.isPreliminaryDeliveryDate ? 'warning' : 'success';
  }

  public get preliminaryIcon(): string {
    return this.isPreliminaryDeliveryDate ? 'calendar-xmark' : 'calendar-check';
  }

  constructor(
    public readonly id: IMSId,
    label: string,
    labelFormatSettings: LabelFormatSetting,
    public car: IMSObject,
    public description: string,
    public deliverydate: number
  ) {
    super(
      id.imsId,
      id.secondaryId,
      label,
      'ims/MaterialDelivery',
      labelFormatSettings
    );
  }
}

export interface MaterialDeliveryDTO {
  id: number;
  secondaryid: number;
  label: string;
  car: {
    id: number;
    label: string;
  };
  description: string;
  deliverydate: number;
}
